import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { initPwaInstallPrompt } from './utils/pwaInstallPrompt.js'

initPwaInstallPrompt()
const app = createApp(App)

// 全局注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(store)
    .use(router)
    .use(ElementPlus, {
        locale: zhCn,
    })
    .mount('#app')

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        const baseUrl = process.env.BASE_URL || '/'
        navigator.serviceWorker.register(`${baseUrl}service-worker.js`).catch(() => {})
    })
}
